import { Checkbox, useCheckoutPlan, useResponsive } from '@shamaazi/mytennights'
import { type FC } from 'react'

export const AutoEnrolCheckbox: FC = () => {
  const { plan, setPlan } = useCheckoutPlan()
  const { isMobile } = useResponsive()

  const onToggleCheck = (): void => {
    const newAutoEnroll = plan.autoEnroll === 'true' ? 'false' : 'true'
    setPlan({ ...plan, autoEnroll: newAutoEnroll })
  }

  return <div className="flex mt-4 items-center" onClick={() => {
    isMobile && onToggleCheck()
  }}>
            <Checkbox
              isChecked={plan.autoEnroll === 'true'}
            //   TODO: add mtd id
            //   dataTestId={MytennightsTestId.marketingOptIn_ + PaymentFormProps.emailOptIn}
            fillColour='mtd-blue-1'
            isRounded={true}
            toggleCheck={() => onToggleCheck()}
            />
            <label className='text-sm text-mtd-secondary-5 font-semibold'>Automate your yearly donations</label>
        </div>
}
